import { Injectable, inject } from '@angular/core';

import { TranslateLoader } from '@ngx-translate/core';
import { PaymentsApiService } from '@payments/common-utils';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CustomTranslateLoaderService implements TranslateLoader {
    paymentsApiService = inject(PaymentsApiService);

    getTranslation(_langCountry: string): Observable<any> {
        return this.getContent();
    }

    getContent(): Observable<{ [key: string]: string }> {
        return this.paymentsApiService.get('PaymentsApi/content?cashierType=QuickDeposit');
    }
}
